import { LitElement, html } from '@hh/global.js'

class HHLoadMore extends LitElement {
  static properties = {
    url: {
      type: String,
    },
    position: {
      type: String,
    },
    'target-class': {
      type: String,
    },
  }

  constructor() {
    super()
    this.position = 'next'
  }

  connectedCallback() {
    super.connectedCallback()
    this.addEventListener('submit', this.handleLoadMore.bind(this))
  }

  disconnectedCallback() {
    super.disconnectedCallback()
  }

  async handleLoadMore(e) {
    e.preventDefault()
    try {
      const url = this['url']
      const targetClass = this['target-class']

      this.setButtonLoading()

      if (this.position === 'next') {
        this.setPageUrl(url)
      }

      const res = await fetch(url)
      const data = await res.text()
      const dataDom = await new DOMParser().parseFromString(data, 'text/html')

      const newData = dataDom.querySelector(targetClass)
      document
        .querySelector(targetClass)
        .insertAdjacentHTML(
          this.position === 'previous' ? 'afterbegin' : 'beforeend',
          newData.innerHTML
        )

      this.rerenderComponent(dataDom)
    } catch (error) {
      console.error(error)
    }
  }

  setButtonLoading() {
    const buttonEl = this.querySelector('.js-load-more, button[type="submit]')

    buttonEl.classList.add('is-loading')
    buttonEl.setAttribute('disabled', true)
  }

  rerenderComponent(data) {
    if (!data) return
    const elId = `#${this.getAttribute('id')}`

    const newLoadMore = data.querySelector(elId)?.outerHTML || ''
    this.outerHTML = newLoadMore
  }

  setPageUrl(url) {
    window.history.pushState({}, '', url)
  }

  render() {
    return html` <slot></slot> `
  }
}

customElements.define('hh-load-more', HHLoadMore)
